module.exports = __webpack_public_path__ + "img/palmar-room-3.4497d987.jpg";